module.exports = __webpack_public_path__ + "static/media/Icon awesome-linkedin.158d86e5.svg";